import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiService } from 'src/app/Services/api.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-flowbirdconfig',
    templateUrl: './flowbirdconfig.component.html',
    styleUrls: ['./flowbirdconfig.component.scss'],
    standalone: false
})
export class FlowbirdConfigComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Model: any;
  private destroy$ = new Subject<void>();

  constructor(private apiService: ApiService, private parentRoute: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => { this.ModelId = params['id']; });

    this.apiService.Get<any>("integrations/flowbird/configurations/" + this.ModelId).then(result => {
      this.Model = result;
      this.StopLoading();
    })
    .catch(error => {
      console.error('Failed to load Flowbird configuration', error);
      this.StopLoading();
    });
  }

  ngOnDestroy() : void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
